import { Entity } from "@common/types/entity";
import { JournalEntryScope } from "./journalEntryScope";

type JournalEntryEntity = Pick<Entity, "id" | "legalType" | "name">;

interface ResolveJournalEntryScopeParams {
    selectedScope: JournalEntryScope;
    availableEntities: readonly Entity[];
    initialEntity: JournalEntryEntity;
    readyConsolidationGroupId?: string;
}

interface ResolvedJournalEntryScope {
    scope: JournalEntryScope;
    entity: JournalEntryEntity;
}

export function resolveJournalEntryScope({
    selectedScope,
    availableEntities,
    initialEntity,
    readyConsolidationGroupId,
}: ResolveJournalEntryScopeParams): ResolvedJournalEntryScope {
    const fallbackEntity =
        availableEntities.find((entity) => entity.id === initialEntity.id) ??
        availableEntities[0] ??
        initialEntity;

    if (selectedScope.kind === "entity") {
        const selectedEntity = availableEntities.find(
            (entity) => entity.id === selectedScope.entityId,
        );
        if (selectedEntity) {
            return { scope: selectedScope, entity: selectedEntity };
        }
    } else if (
        selectedScope.consolidationGroupId === readyConsolidationGroupId
    ) {
        return { scope: selectedScope, entity: fallbackEntity };
    }

    return {
        scope: { kind: "entity", entityId: fallbackEntity.id },
        entity: fallbackEntity,
    };
}
